import React, { useState } from "react"
import "../assets/sass/partials/_page-stories-image.scss"
import scrollToElement from "scroll-to-element"
import OfficesSliderTowerUpper from "../components/officesSliderTowerUpper"
import OfficesSliderTowerLower from "../components/officesSliderTowerLower"
import OfficesSliderSquareOne from "../components/officesSliderSquareOne"
import OfficesSliderSquareTwo from "../components/officesSliderSquareTwo"
import OfficesSliderSquareOneFirstFloor from "../components/officesSliderSquareOne-FirstFloor"
import OfficesSliderSquareOneFifthFloor from "../components/officesSliderSquareOne-FifthFloor"
import OfficesSliderTowerLowerFirstSecondFloor from "./officesSliderTowerLower-FirstSecondFloor"
import OfficesSliderSquareTwoFirstFloor from "./officesSliderSquareTwo-FirstFloor"

const StoresViewSvg = ({ lang, floor }) => {
  const [tab, setTab] = useState("")

  const [state, setState] = React.useState({
    selectedSlot: { "0": "00", "1": "11" },
    cal: 1
  })

  const initialState = {
    tab: "",
  };

  const clearState = () => {
    setState({ ...initialState });
  };


  return (
    <>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 4160 3030"
        transform="translate(0 0)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="42">
          <g
            id="Ellipse_1"
            data-name="Ellipse 1"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
            transform="translate(16980 21315)"
            cursor="pointer"
          >
            <ellipse cx="20.5" cy="21" rx="20.5" ry="21" stroke="none" />
            <ellipse cx="20.5" cy="21" rx="20" ry="20.5" fill="none" />
          </g>
        </svg>

        <svg width="100%" height="100%">
          <g transform="translate(16980 21180)" cursor="pointer">
            <path
              id="Path_3286"
              data-name="Path 3286"
              d="M-15493.53-19367.738v54.809l143.293,54.146,399.5-4.621,505.82-278.664v-55.469l-505.82,269.418-402.807,12.547Z"
              onClick={e => {
                setTab("4")
                scrollToElement("#offices")
                clearState()
              }}
              className={tab === "4 cls-1" ? "current" : ""}
              className={floor === "4 cls-1" ? "current" : ""}
            />
            <title>Floor 1</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21180)" cursor="pointer">
            <path
              id="Path_3287"
              data-name="Path 3287"
              d="M-15493.53-19367.643l139.572,51.791,403.218-12.254,511.189-273.051v-45.547l-515.582,254.322-397.669,14.566-141.728-48.322Z"
              onClick={e => {
                setTab("2")
                scrollToElement("#offices")
              }}
              className={tab === "2 cls-1" ? "current" : ""}
            />
            <title>Floor 2</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21180)" cursor="pointer">
            <path
              id="Path_3288"
              data-name="Path 3288"
              d="M-15494.529-19426.6l-1.619-61.732,140.341,48.783,399.75-12.021,518.588-246-2.081,50.4-515.352,254.785-399.056,14.566Z"
              onClick={e => {
                setTab("2")
                scrollToElement("#offices")
              }}
              className={tab === "2 cls-1" ? "current" : ""}
            />
            <title>Floor 3</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21180)" cursor="pointer">
            <path
              id="Path_3289"
              data-name="Path 3289"
              d="M-15496.148-19489.254l-1.155-58.033,141.033,43.93,399.288-12.717,518.126-234.209v52.252l-516.971,246.693-400.443,12.023Z"
              onClick={e => {
                setTab("2")
                scrollToElement("#offices")
              }}
              className={tab === "2 cls-1" ? "current" : ""}
            />
            <title>Floor 4</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21180)" cursor="pointer">
            <path
              id="Path_3290"
              data-name="Path 3290"
              d="M-15497.3-19547.98v-64.967l140.34,41.848,340.562-10.4,546.8-227.043v39.074l30.519,9.479v9.248l-519.051,234.441-398.825,12.715Z"
              onClick={e => {
                setTab("5")
                scrollToElement("#offices")
              }}
              className={tab === "5 cls-1" ? "current" : ""}
            />
            <title>Floor 5</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21190)" cursor="pointer">
            <path
              id="Path_3291"
              data-name="Path 3291"
              d="M-14349.675-19930.908l-237.176,86.744,125.426,25.4v6.643l-7.033,3.908v10.939l32.04-10.939v-74.24l86.743-32.822Z"
              onClick={e => {
                setTab("6")
                scrollToElement("#offices")
              }}
              className={tab === "6 cls-1" ? "current" : ""}
            />
            <title>Floor 1-2</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3292"
              data-name="Path 3292"
              d="M-14349.675-19930.908l1.678-38.881-280.59,97.818-245.847-44.332v41.725l115.328,24.352,49.661-16.416,121.758,22.3Z"
              onClick={e => {
                setTab("11")
                scrollToElement("#offices")
              }}
              className={tab === "11 cls-1" ? "current" : ""}
            />
            <title>Floor 4</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3293"
              data-name="Path 3293"
              d="M-14348-19969.789l1.227-39.406-281.548,95.08-245.842-43.367v41.043l245.842,44.461Z"
              onClick={e => {
                setTab("11")
                scrollToElement("#offices")
              }}
              className={tab === "11 cls-1" ? "current" : ""}
            />
            <title>Floor 5</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3294"
              data-name="Path 3294"
              d="M-14346.771-20009.2l.548-38.443-282.643,88.652-245.979-41.453v42.547l245.979,43.914Z"
              onClick={e => {
                setTab("11")
                scrollToElement("#offices")
              }}
              className={tab === "11 cls-1" ? "current" : ""}
            />
            <title>Floor 6</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3295"
              data-name="Path 3295"
              d="M-14346.223-20047.639v-42.684l-282.1,81.947-247.072-39.674v46.789l247.072,42.137Z"
              onClick={e => {
                setTab("11")
                scrollToElement("#offices")
              }}
              className={tab === "11 cls-1" ? "current" : ""}
            />
            <title>Floor 7</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3298"
              data-name="Path 3298"
              d="M-14872.659-20126.6l.647-17.322,19.672-4.615v-15.705l196.791,26.311,19.509-4.7,28.575,2.832,181.815-45.979,82.488,8.66-.729,9.311-284.865,75.77-244.471-33.352Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 10</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3299"
              data-name="Path 3299"
              d="M-14852.664-20164.889v-42.256l197.2,23.232,20.076-3.48,28.656,2.59,182.625-41.2-1.295,40.395-182.3,45.9-28.171-3.076-19.591,4.7Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 11</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3300"
              data-name="Path 3300"
              d="M-14852.664-20207.631v-42.338l197.763,21.777,19.752-3.076,29.951,1.133,182.544-36.51-1.457,40.557-183.354,41.205-28.575-2.43-19.509,3.563Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 12</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3301"
              data-name="Path 3301"
              d="M-14852.988-20250.453v-42.9l198.572,19.752,21.128-2.348,28.333,1.781,157.854-30.68-.566,28.656,24.69,3.238v6.395l-182.625,36.67-29.79-1.457-19.671,3.238Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 13</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21195)" cursor="pointer">
            <path
              id="Path_3302"
              data-name="Path 3302"
              d="M-14852.988-20293.844v-41.932l198.815,17.566,20.318-2.51,29.709,2.51,157.449-28.172-.567,41.367-158.016,30.68-28.575-1.619-20.966,2.348Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 14</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3303"
              data-name="Path 3303"
              d="M-14852.988-20336.1v-41.932l199.058,15.137,20.643-2.1,29.628,1.375,158.259-23.8-1.133,41.041-158.34,28.334-29.628-2.914-20.237,2.914Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 15</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3304"
              data-name="Path 3304"
              d="M-14852.988-20378.68v-43.309l197.034,12.871,22.666-1.457,29.224.891,159.392-20.8-.566,43.066-158.825,23.8-29.224-1.537-21.047,2.348Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 16</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3305"
              data-name="Path 3305"
              d="M-14852.988-20422.15v-42.984l197.763,11.576,23.313-2.186,28.9.971,158.583-18.457v42.986l-160.606,20.8-29.79-1.213-21.775,1.537Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 17</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3306"
              data-name="Path 3306"
              d="M-14853.316-20465.586v-42.77l199.755,9.154,21.679-1.789,30.624,1.789,157.959-15.891-1.053,41.99-159.116,18.416-28.414-1.369-24.415,2.527Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 18</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21205)" cursor="pointer">
            <path
              id="Path_3307"
              data-name="Path 3307"
              d="M-14853.316-20508.566l.544-43.988,198.264,7.262,23.468-1.789h28.414l160.59-12-1.158,43.883-158.484,16.207-29.361-1.895-22.836,1.895Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 19</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21210)" cursor="pointer">
            <path
              id="Path_3308"
              data-name="Path 3308"
              d="M-14853.316-20552.871l.754-48.83,198.37,4.525,23.678-1.262,30.834.736,158.169-8.523-.631,47.355-161.326,11.891h-26.1l-24.625,1.58Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 20</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21205)" cursor="pointer">
            <path
              id="Path_3309"
              data-name="Path 3309"
              d="M-14852.668-20601.91v-38.518l197.844,2.211h56.933l156.7-7.893-.632,39.674-158.274,8.629-30.834-.525-22.836,1.156Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 21</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21210)" cursor="pointer">
            <path
              id="Path_3310"
              data-name="Path 3310"
              d="M-14852.668-20640.742v-44.41l200.475.525,55.67-.945,151.224-3.369v35.887h4.525v6.84l-157.328,8.209h-52.828Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 22</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21210)" cursor="pointer">
            <path
              id="Path_3311"
              data-name="Path 3311"
              d="M-14852.668-20685.678v-44.936l225.311-.842,101.657-.211,81.453-1.264-1.263,43.988-143.857,3.053-62.511,1.158-132.176-.211Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 23</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21210)" cursor="pointer">
            <path
              id="Path_3312"
              data-name="Path 3312"
              d="M-14851.337-20730.6v-44.861l253.858-3.238,153.52,1.389v44.158l-191.437,1.389Z"
              onClick={e => {
                setTab("1")
                scrollToElement("#offices")
              }}
              className={tab === "1 cls-1" ? "current" : ""}
            />
            <title>Floor 24</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21190)" cursor="pointer">
            <path
              id="Path_3313"
              data-name="Path 3313"
              d="M-14874.434-19874.324v42.824l37.763,8.418,78.117-27.2Z"
              onClick={e => {
                setTab("11")
                scrollToElement("#offices")
              }}
              className={tab === "11 cls-1" ? "current" : ""}
            />
            <title>Floor 3</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21190)" cursor="pointer">
            <path
              id="Path_3314"
              data-name="Path 3314"
              d="M-14997.836-19807.586l17.43,2.846,13.694-4.092,72.563-26.5,19.741,3.736v-36.1l-93.371,28.1-30.057-4.8Z"
              onClick={e => {
                setTab("7")
                scrollToElement("#offices")
              }}
              className={tab === "7 cls-1" ? "current" : ""}
            />
            <title>Floor 1</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3315"
              data-name="Path 3315"
              d="M-14997.836-19845.291v-39.482l30.412,5.691,93.016-29.523v41.084l-93.016,27.744Z"
              onClick={e => {
                setTab("3")
                scrollToElement("#offices")
              }}
              className={tab === "3 cls-1" ? "current" : ""}
            />
            <title>Floor 2</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3316"
              data-name="Path 3316"
              d="M-14997.836-19884.951v-40.371l29.523,4.623,93.548-27.389v39.838l-93.548,28.99Z"
              onClick={e => {
                setTab("3")
                scrollToElement("#offices")
              }}
              className={tab === "3 cls-1" ? "current" : ""}
            />
            <title>Floor 3</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3317"
              data-name="Path 3317"
              d="M-14997.836-19925.855v-41.262l29.167,4.8,93.549-25.611v39.482l-93.549,28.1Z"
              onClick={e => {
                setTab("3")
                scrollToElement("#offices")
              }}
              className={tab === "3 cls-1" ? "current" : ""}
            />
            <title>Floor 4</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3318"
              data-name="Path 3318"
              d="M-14998.726-20003.221v35.748l30.234,5.336,93.371-25.434v-35.748l-93.371,24.365Z"
              onClick={e => {
                setTab("3")
                scrollToElement("#offices")
              }}
              className={tab === "3 cls-1" ? "current" : ""}
            />
            <title>Floor 5-6</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3319"
              data-name="Path 3319"
              d="M-14999.792-20003.043l.889-42.506,30.946,3.557,92.837-22.053v41.262l-93.727,23.652Z"
              onClick={e => {
                setTab("3")
                scrollToElement("#offices")
              }}
              className={tab === "3 cls-1" ? "current" : ""}
            />
            <title>Floor 7</title>
          </g>
        </svg>
        <svg width="100%" height="100%">
          <g transform="translate(16980 21200)" cursor="pointer">
            <path
              id="Path_3320"
              data-name="Path 3320"
              d="M-14999.792-20046.082l1.066-41.439,29.346,4.27,95.86-23.654-1.423,42.684-93.192,22.23Z"
              onClick={e => {
                setTab("3")
                scrollToElement("#offices")
              }}
              className={tab === "3 cls-1" ? "current" : ""}
            />
            <title>Floor 8</title>
          </g>
        </svg>
      </svg>
      <section className="offices-schema global__padd--bigger" id="offices">
        {tab === "1" ? (
          <OfficesSliderTowerUpper lang={lang} />
        ) : tab === "11" ? (
          <OfficesSliderTowerLower lang={lang} />
        ) : tab === "2" ? (
          <OfficesSliderSquareOne lang={lang} />
        ) : tab === "3" ? (
          <OfficesSliderSquareTwo lang={lang} />
        ) : tab === "4" ? (
          <OfficesSliderSquareOneFirstFloor lang={lang} />
        ) : tab === "5" ? (
          <OfficesSliderSquareOneFifthFloor lang={lang} />
        ) : tab === "6" ? (
          <OfficesSliderTowerLowerFirstSecondFloor lang={lang} />
        ) : tab === "7" ? (
          <OfficesSliderSquareTwoFirstFloor lang={lang} />
        ) : floor === "1" ? (
          <OfficesSliderTowerUpper lang={lang} />
        ) : floor === "11" ? (
          <OfficesSliderTowerLower lang={lang} />
        ) : floor === "2" ? (
          <OfficesSliderSquareOne lang={lang} />
        ) : floor === "3" ? (
          <OfficesSliderSquareTwo lang={lang} />
        ) : (
          ""
        )}
      </section>
    </>
  )
}

export default StoresViewSvg
